import axiosInstance from '@/axiosInstance'

export default {
  namespaced: true,
  state: () => ({
    projects: JSON.parse(sessionStorage.getItem('projects') || '[]'),
    isFetched: sessionStorage.getItem('projectsFetched') === 'true'
  }),
  mutations: {
    setProjects(state, projects) {
      state.projects = projects
      state.isFetched = true
      // Cache to sessionStorage
      sessionStorage.setItem('projects', JSON.stringify(projects))
      sessionStorage.setItem('projectsFetched', 'true')
    },
    clearProjects(state) {
      state.projects = []
      state.isFetched = false
      sessionStorage.removeItem('projects')
      sessionStorage.removeItem('projectsFetched')
    }
  },
  actions: {
    async fetchProjects({ commit, state }) {
      if (state.isFetched) return
      try {
        const response = await axiosInstance.get('projects/')
        commit('setProjects', response.data)
      } catch (error) {
        console.error('Error fetching project:', error)
      }
    },
    async refetchprojects({ commit, dispatch }) {
      commit('clearProjects')
      await dispatch('fetchProjects')
    }
  },
  getters: {
    projects: state => state.projects,
    isFetched: state => state.isFetched
  }
}